import React from "react";
import { Navigate } from "react-router";
import { usePermissions } from "src/contexts/permissions";
import useAuth from "src/hooks/useAuth";

// User::INTERNAL_USER_ROLES (User#internal_user?).
const INTERNAL_USER_ROLES = ["admin", "super_admin", "manager", "inventory", "billing_user"];

// Ask Glimpse is for internal users only, in a company that opted in (settings.ask_glimpse). The opt-in
// must be stored as true: can("settings.x") treats a setting the company never saved as allowed, and
// no existing company has saved this one. The server enforces both (askGlimpseToken refuses).
export const canAskGlimpse = (_can, role, settings) => {
  const optedIn = settings?.ask_glimpse === true || settings?.ask_glimpse === "true";
  return optedIn && INTERNAL_USER_ROLES.includes(role);
};

const AskGlimpseGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { can, settings } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!canAskGlimpse(can, user?.role, settings)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};

export default AskGlimpseGuard;
